import { HubspotFormhandlerSubscribe } from '../_components/hubspot-formhandlers/_subscribe';

$( document ).ready( function () {
    HubspotFormhandlerSubscribe();
} );